import { Link } from "react-router-dom";

interface Props {
  eyebrow?: string;
  title: string;
  subtitle?: string;
  to?: string;
  linkText?: string;
  align?: "left" | "center";
}

export default function SectionHeader({ eyebrow, title, subtitle, to, linkText, align = "left" }: Props) {
  return (
    <div className={`mb-8 flex flex-col gap-2 md:mb-10 ${align === "center" ? "items-center text-center" : "md:flex-row md:items-end md:justify-between"}`}>
      <div className={align === "center" ? "flex flex-col items-center" : ""}>
        {eyebrow && (
          <span className="mb-2 inline-flex items-center gap-1.5 text-xs font-semibold uppercase tracking-wider text-accent-600">
            <i className="ri-sparkling-2-fill" />
            {eyebrow}
          </span>
        )}
        <h2 className="font-heading text-2xl font-bold text-foreground-950 md:text-3xl">{title}</h2>
        {subtitle && <p className={`mt-2 max-w-2xl text-sm leading-relaxed text-foreground-600 ${align === "center" ? "mx-auto" : ""}`}>{subtitle}</p>}
      </div>
      {to && linkText && (
        <Link to={to} className="btn btn-ghost shrink-0">
          {linkText}
          <i className="ri-arrow-right-line" />
        </Link>
      )}
    </div>
  );
}